import { render } from "./DownloadTranscriptsView.vue?vue&type=template&id=bf01a4de"
import script from "./DownloadTranscriptsView.vue?vue&type=script&lang=js"
export * from "./DownloadTranscriptsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__